import { customFetch, AuthClient, decodeToken } from '@skytech/auth'
import { config } from '@skytech/config'
import type { Locale } from '@skytech/types'

import type { TokenData } from '@/types'
import { get } from '@/util/auth'
import getUserFromToken from '@/util/getUserFromToken'

type Profile = {
  id: number
  name: string
  email: string
  locale: Locale
  type: string
  customerId: number
  allowSubscriptions: number
  activitiesCount: number
  canUpdateMobileSubscription: boolean
}

const userResources = {
  get: async () => {
    const res = await customFetch<{ token: string }>({
      path: 'app/token',
      environment: config.AUTH_API_URL,
      credentials: 'include',
    })

    const tokenData: TokenData = decodeToken(res.token)
    const user = getUserFromToken(tokenData)
    AuthClient.setToken(res.token)

    return user
  },

  profile: async () => {
    const res = await get<Profile>('auth/profile', true)

    return res
  },
}

export default userResources
